import { restService } from "./RestService";

export class AuthService {
    constructor(baseUrl) {
        this.baseUrl = baseUrl;
    }

    async login(credentials) {
        const url = `${this.baseUrl}/auth/login`;

        try {
            const user = await restService.post(url, credentials);
            return user;
        } catch (error) {
            this.handleError(error, 'Login failed');
        }
    }

    async validateSession() {
        const url = `${this.baseUrl}/auth/validateSession`;

        try {
            return await restService.post(url);
        } catch (error) {
            this.handleError(error, 'Session invalid');
        }
    }

    async logout() {
        const url = `${this.baseUrl}/auth/logout`;

        try {
            await restService.post(url);
        } catch (error) {
            this.handleError(error, 'Unable to log out');
        }
    }

    handleError = (error, message) => {
        throw new Error(message, { cause: error });
    }
}